module.exports = __webpack_public_path__ + "static/media/check-circle.3888176c.svg";